import { render } from "./zcfzTable4.vue?vue&type=template&id=383ba5fb&scoped=true"
import script from "./zcfzTable4.vue?vue&type=script&lang=js"
export * from "./zcfzTable4.vue?vue&type=script&lang=js"

import "./zcfzTable4.vue?vue&type=style&index=0&id=383ba5fb&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-383ba5fb"]])

export default __exports__